import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

interface IBadge {
  height?: number;
  width?: number;
}

const Badge = styled.img<IBadge>`
  width: ${(props) => (props.width || 80) * Screen.widthRatio}px;
  height: ${(props) => (props.height || 0) * Screen.widthRatio || 'initial'}px;
`;

export default withImage(Badge, false);
